import { humanoidFace, humanoidSkull } from './humanoid-head.js';
import type { HumanSkull, HumanFace, HumanRigId } from './human.js';
import { NOSE_SHAPE_DEFAULT } from './humanoid-nose.js';

/** Goblin bone structure: wide temples and eyes, pinched chin, swept ears and a long hooked nose. */
export function goblinSkull(body: HumanRigId = 'human-male'): HumanSkull {
  const skull = humanoidSkull(body, .8, 1.25);
  return {
    ...skull,
    eye: { x: .041, y: 1.851, plane: .076, opening: .8 },
    eyebrows: { angular: true, thickness: 1.45, arch: .6, slope: -.0016 },
    ear: { ...skull.ear, length: .032, width: .021, thickness: .007,
      pointed: true, pointLength: .046, pointOutward: .06, pointBack: .04 },
    mouth: { y: 1.784, width: .035, upper: .8, lower: .9, forward: 1.05, bow: .4,
      corners: .002, groove: .0015, overlap: .0006, lift: .0005, upperJaw: 0, lowerJaw: .013 },
    nose: { ...NOSE_SHAPE_DEFAULT, rootY: 1.866, length: .062, tipZ: .106, wingFlare: 1.1,
      curve: { projection: .046, arch: .006, hook: .022, ridge: .003, crest: .0058, crestAt: .45, crestLength: .35, tip: .0045, spread: .0105, baseY: 1.797 } },
  };
}
export function goblinFace(body: HumanRigId): HumanFace {
  return { ...humanoidFace(body, { jaw: 1, chin: .8, square: 1.1 }, { chinDepth: .002 }), brow: .003, cheek: .03,
  hollow: .045, eye: .009, eyeSize: 1.14, nose: 1.03, lips: .65, noseLength: 0,
  bridge: .002, fullness: 0, eyeTilt: -.08, fold: .0025 };
}
